import React, { useState } from 'react';
import {
  Dialog,
  Box,
  DialogTitle,
  List,
  Divider,
  ListItem,
  ListItemText,
} from '@material-ui/core';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { publish } from 'services/CentrifugoWS';
import CloseButton from 'components/CustomButtons/CloseButton';

import {
  customerPhoneSearchMessage,
  customerEmailSearchMessage,
  customerRegistryCodeSearchMessage,
} from '../constants';
import { getChannelName } from '../rdx/reducer';

import { ActionButton } from '.';

type Props = {
  startNewSaleIfNeeded(): void;
  textStyle: React.CSSProperties;
};

const SearchCustomer: React.FC<Props> = ({
  startNewSaleIfNeeded,
  textStyle,
}) => {
  const channelName = useSelector(getChannelName);
  const channel = `customer_display:${channelName}`;

  const { t } = useTranslation('customerDisplay', {
    keyPrefix: 'headerIcon.searchCustomer',
  });

  const [open, setOpen] = useState(false);

  function searchCustomerByEmail() {
    startNewSaleIfNeeded();
    publish({ message: customerEmailSearchMessage, channel });
    setOpen(false);
  }

  function searchCustomerByPhone() {
    startNewSaleIfNeeded();
    publish({ message: customerPhoneSearchMessage, channel });
    setOpen(false);
  }

  function searchCustomerByRegistryCode() {
    startNewSaleIfNeeded();
    publish({ message: customerRegistryCodeSearchMessage, channel });
    setOpen(false);
  }

  return (
    <>
      <ActionButton
        onClick={() => setOpen(true)}
        variant="contained"
        color="primary"
        fullWidth
        startIcon={<span style={textStyle}>{t('tooltip')}</span>}
      >
        <span className="icon_profile" />
        <span className="icon_search" />
      </ActionButton>
      <Dialog open={open} onClose={() => setOpen(false)}>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <DialogTitle>{t<string>('title')}</DialogTitle>
          <CloseButton
            style={{ fontSize: '42px', height: 'auto', padding: '0.75rem' }}
            action={() => setOpen(false)}
          />
        </Box>
        <Divider />
        <List>
          <ListItem button onClick={searchCustomerByEmail}>
            <ListItemText>{t<string>('email')}</ListItemText>
          </ListItem>
          <ListItem button onClick={searchCustomerByRegistryCode}>
            <ListItemText>{t<string>('code')}</ListItemText>
          </ListItem>
          <ListItem button onClick={searchCustomerByPhone}>
            <ListItemText>{t<string>('phone')}</ListItemText>
          </ListItem>
        </List>
      </Dialog>
    </>
  );
};

export default SearchCustomer;
